import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const TrustPilotWidget = dynamic(() => import('./TrustPilot'));

const TrustPilotWidgetConfig = {
  name: 'Trustpilot',
  inputs: [
    {
      name: 'layout',
      type: 'enum',
      defaultValue: 'micro',
      enum: [
        {
          label: 'Micro',
          value: 'micro',
        },
        {
          label: 'List',
          value: 'list',
        },
        {
          label: 'Mini',
          value: 'mini',
        },
        {
          label: 'Micro Review Count',
          value: 'microReviewCount',
        },
      ],
    },
    {
      name: 'variant',
      type: 'enum',
      defaultValue: 'dark',
      enum: [
        {
          label: 'dark',
          value: 'dark',
        },
        {
          label: 'light',
          value: 'light',
        },
      ],
    },
  ],
};

Builder.registerComponent(TrustPilotWidget, TrustPilotWidgetConfig);
